import React from 'react';

/**
 * Global site-wide background — plain solid color, no decorative elements.
 * Apple Podcasts-inspired: clean, uncluttered.
 */
export default function SiteBackground() {
  return (
    <div
      aria-hidden
      className="fixed inset-0 pointer-events-none"
      style={{ zIndex: 0, background: 'var(--pd-bg)' }}
      data-testid="site-background"
    />
  );
}
